import axios from 'axios'
import $http from '../utils/request.js'
const app_id = 10008;

//商品分类列表
export const getCategory = (wxapp_id = app_id) => $http.get(`/index.php?s=/api/category/lists&wxapp_id=${wxapp_id}`)
//商品列表
export const getList = (page, sortType, sortPrice, category_id, search, tags = "", wxapp_id = app_id) => $http.get(`/index.php?s=/api/goods/lists&page=${page}&sortType=${sortType}&sortPrice=${sortPrice}&category_id=${category_id}&search=${search}&wxapp_id=${wxapp_id}&tags=${tags}`)
//商品详情
export const getdetail = (goods_id, wxapp_id = app_id) => $http.get(`/index.php?s=/api/goods/detail&goods_id=${goods_id}&wxapp_id=${wxapp_id}`)
//推广二维码
export const getposter = (goods_id, wxapp_id = app_id) => axios.get(`/index.php?s=/api/goods/poster&goods_id=${goods_id}&wxapp_id=${wxapp_id}`)
//登录
export const mLogin = (mobile, code, wxapp_id = app_id) => $http.get(`/index.php?s=/api/user/login_mobile&wxapp_id=${wxapp_id}&mobile=${mobile}&code=${code}`)
//图片验证码
export const captcha = (size = 20, height = 35, width = 120, length = 3) => $http.get(`/api/captcha?size=${size}&height=${height}&width=${width}&length=${length}`)
//短信验证码
export const code = (mobile, captcha_id, captcha, template = "login") => $http.get(`/api/sms/code?mobile=${mobile}&template=${template}&captcha_id=${captcha_id}&captcha=${captcha}`)
//登录
export const login_mobile = (mobile, code, wxapp_id = app_id) => $http.get(`/index.php?s=/api/user/login_mobile&wxapp_id=${wxapp_id}&mobile=${mobile}&code=${code}`)
//根据goodsID获取商品列表
export const getListById = (ids, wxapp_id = app_id) => $http.get(`/index.php?s=/api/goods/ids&wxapp_id=${wxapp_id}&ids=${ids}`)
//获取圈层token
export const tokens = (wxapp_id, token) => $http.get(`/api/user/login_abc&wxapp_id=${wxapp_id}&token=${token}`)
//获取圈层token
export const userinfo = (token, wxapp_id = app_id) => $http.get(`/index.php?s=/api/user/info&wxapp_id=${wxapp_id}&token=${token}`)
//活动首页轮播
export const activeHome = (name = "",wxapp_id = app_id) => $http.get(`/index.php?s=/api/pad_active/home&name=${name}&wxapp_id=${wxapp_id}`)
//活动列表
export const activeList = (pad_ad_id,page,wxapp_id = app_id) => $http.get(`/index.php?s=/api/pad_active/lists&wxapp_id=${wxapp_id}&page=${page}&pad_ad_id=${pad_ad_id}`)
//活动详情
export const activeDetail = (id,wxapp_id = app_id) => $http.get(`/index.php?s=/api/pad_active/detail&wxapp_id=${wxapp_id}&id=${id}`)
//屏幕保护
export const screen = (wxapp_id = app_id) => $http.get(`/index.php?s=/api/pad_active/screen&wxapp_id=${wxapp_id}`)

// export const getCategory = (wxapp_id = app_id) => $http.post(`/index.php?s=/api/category/lists`,{wxapp_id:wxapp_id})
// //商品列表
// export const getList = (page, sortType, sortPrice, category_id, search="", tags = "", wxapp_id = app_id) => $http.post(`/index.php?s=/api/goods/lists`,{page:page,sortType:sortType,sortPrice:sortPrice,category_id:category_id,search:search,wxapp_id:wxapp_id,tags:tags})
// //商品详情
// export const getdetail = (goods_id, wxapp_id = app_id) => $http.post(`/index.php?s=/api/goods/detail`,{goods_id:goods_id,wxapp_id:wxapp_id})
// //推广二维码
// export const getposter = (goods_id, wxapp_id = app_id) => axios.post(`/index.php?s=/api/goods/poster`,{goods_id:goods_id,wxapp_id:wxapp_id})
// //登录
// export const mLogin = (mobile, code, wxapp_id = app_id) => $http.post(`/index.php?s=/api/user/login_mobile`,{wxapp_id:wxapp_id,mobile:mobile,code:code})
// //图片验证码
// export const captcha = (size = 20, height = 35, width = 120, length = 3) => $http.post(`/api/captcha`,{size:size,height:height,width:width,length:length})
// //短信验证码
// export const code = (mobile, captcha_id, captcha, template = "login") => $http.post(`/api/sms/code`,{mobile:mobile,template:template,captcha_id:captcha_id,captcha:captcha})
// //登录
// export const login_mobile = (mobile, code, wxapp_id = app_id) => $http.post(`/index.php?s=/api/user/login_mobile`,{wxapp_id:wxapp_id,mobile:mobile,code:code})
// //根据goodsID获取商品列表
// export const getListById = (ids, wxapp_id = app_id) => $http.post(`/index.php?s=/api/goods/ids`,{wxapp_id:wxapp_id,ids:ids})
// //获取圈层token
// export const tokens = (wxapp_id, token) => $http.post(`/api/user/login_abc`,{wxapp_id:wxapp_id,token:token})
// //获取圈层token
// export const userinfo = (token, wxapp_id = app_id) => $http.post(`/index.php?s=/api/user/info`,{wxapp_id:wxapp_id,token:token})
// //活动首页轮播
// export const activeHome = (name = "",wxapp_id = app_id) => $http.post(`/index.php?s=/api/pad_active/home`,{name:name,wxapp_id:wxapp_id})
// //活动列表
// export const activeList = (pad_ad_id,page,wxapp_id = app_id) => $http.post(`/index.php?s=/api/pad_active/lists`,{wxapp_id:wxapp_id,page:page,pad_ad_id:pad_ad_id})
// //活动详情
// export const activeDetail = (id,wxapp_id = app_id) => $http.post(`/index.php?s=/api/pad_active/detail`,{wxapp_id:wxapp_id,id:id})